
// Get All Envois
export const getEnvoisStart = ()=>({
    type: 'GET_ENVOIS_START',
})
export const getEnvoisSuccess = (envois)=>({
    type: 'GET_ENVOIS_SUCCESS',
    payload: envois
})
export const getEnvoisFailure = (error)=>({
    type: 'GET_ENVOIS_FAILURE',
    payload: error
})
// Get One Envoie
export const getEnvoieStart = ()=>({
    type: 'GET_ENVOIE_START',
})
export const getEnvoieSuccess = (envoie)=>({
    type: 'GET_ENVOIE_SUCCESS',
    payload: envoie
})
export const getEnvoieFailure = (error)=>({
    type: 'GET_ENVOIE_FAILURE',
    payload: error
})

// Add One Envoie
export const addEnvoieStart = ()=>({
    type: 'ADD_ENVOIE_START',
})
export const addEnvoieSuccess = (envoie)=>({
    type: 'ADD_ENVOIE_SUCCESS',
    payload: envoie
})
export const addEnvoieFailure = (error)=>({
    type: 'ADD_ENVOIE_FAILURE',
    payload: error
})

// update One Envoie
export const updateEnvoieStart = ()=>({
    type: 'UPDATE_ENVOIE_START',
})
export const updateEnvoieSuccess = (envoie)=>({
    type: 'UPDATE_ENVOIE_SUCCESS',
    payload: envoie
})
export const updateEnvoieFailure = (error)=>({
    type: 'UPDATE_ENVOIE_FAILURE',
    payload: error
})

// restart Envoie
export const restartEnvoie = ()=>({
    type: 'RESTART_ENVOIE'
})


// Get All Costs
export const getCostsStart = ()=>({
    type: 'GET_COSTS_START',
})
export const getCostsSuccess = (costs)=>({
    type: 'GET_COSTS_SUCCESS',
    payload: costs
})
export const getCostsFailure = (error)=>({
    type: 'GET_COSTS_FAILURE',
    payload: error
})

// Simulate Cost
export const simulateCostStart = ()=>({
    type: 'SIMULATE_COST_START',
})
export const simulateCostSuccess = (cost)=>({
    type: 'SIMULATE_COST_SUCCESS',
    payload: cost
})
export const simulateCostFailure = (error)=>({
    type: 'SIMULATE_COST_FAILURE',
    payload: error
})

// Update Cost
export const updateCostsStart = ()=>({
    type: 'UPDATE_COSTS_START',
})
export const updateCostsSuccess = (costsUpdated)=>({
    type: 'UPDATE_COSTS_SUCCESS',
    payload: costsUpdated
})
export const updateCostsFailure = (error)=>({
    type: 'UPDATE_COSTS_FAILURE',
    payload: error
})

// Get All History of Envoie
export const getHistoriesEnvoieStart = ()=>({
    type: 'GET_HISTORIES_ENVOIE_START',
})
export const getHistoriesEnvoieSuccess = (histories)=>({
    type: 'GET_HISTORIES_ENVOIE_SUCCESS',
    payload: histories
})
export const getHistoriesEnvoieFailure = (error)=>({
    type: 'GET_HISTORIES_ENVOIE_FAILURE',
    payload: error
})